// Calculate the calendar date in the user's business timezone, not the server's UTC date.
export function getDefaultLaunchDates(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const part = (type) => parts.find((item) => item.type === type).value;
  return {
    launchStart: "2026-01-01",
    launchEnd: `${part("year")}-${part("month")}-${part("day")}`,
  };
}
